var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{class:[_vm.$style['message-bar'],
		{
			[_vm.$style['message-bar--no-radius']]: _vm.noRadius,
			[_vm.$style['message-bar--header']]: _vm.header,
			[_vm.$style['message-bar--' + _vm.type ]]: _vm.type
		}
	]},[_c('div',{class:_vm.$style['message-bar__content']},[(_vm.icon)?_c('FontAwesomeIcon',{class:_vm.$style['message-bar__icon'],attrs:{"icon":['far', _vm.icon],"size":"lg"}}):_vm._e(),_c('span',{class:_vm.$style['message-bar__message']},[_vm._t("default")],2)],1),(_vm.showClose)?_c('BaseIconButton',{on:{"click":function($event){$event.preventDefault();return _vm.close.apply(null, arguments)}}},[_c('FontAwesomeIcon',{attrs:{"icon":['fal', 'times'],"size":"lg"}})],1):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }